module.exports = __webpack_public_path__ + "img/icon-plane.94547e77.svg";